import React from "react";
import { useLocalStore, useObserver } from "mobx-react";
import { Button } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { ErrorCard, Spinner, TabBadge } from "@components";
import { useNavigation } from "@navigation";
import { Form, FormxDebugger } from "@components/formx";
import { FormSection } from "@components/forms";
import { TabFormLayout } from "@components/forms/TabFormLayout";
import { ErrorBoundary } from "@components/error-boundary";
import { CustomerContractEditorStore } from "./CustomerContractEditorStore";
import { FormTab } from "@common/forms/common/FormTab";
import { CustomerContractEditorStoreContext } from "./CustomerContractEditorStoreContext";
import { ContractForm } from "./components/ContractForm/ContractForm";
import { ContactPersonForm } from "./components/ContactPersonForm/ContactPersonForm";

type Props = {
  id: string | null;
};

export function CustomerContractEditor(props: Props) {
  const navigation = useNavigation();

  const localStore = useLocalStore(
    () => new CustomerContractEditorStore(props.id, navigation)
  );

  return useObserver(() => {
    if (localStore.isLoading) {
      return <Spinner />;
    }

    if (localStore.error) {
      return (
        <ErrorCard
          centered={true}
          message={localStore.error}
          title="Error occurred while loading customer contract"
        />
      );
    }

    return (
      <ErrorBoundary>
        <CustomerContractEditorStoreContext.Provider value={localStore}>
          <Form store={localStore.form} allowUpdates>
            <TabFormLayout
              blockId="customer_contract_form"
              canSubmit={localStore.form.canSubmit}
              isDirty={localStore.form.dirty}
              isSubmitting={localStore.form.isSubmitting}
              onSubmit={localStore.form.submit}
              onReset={() => localStore.form.reset()}
              onClose={navigation.close}
              // tabContainerProps={{ withPadding: false }}
              tabs={[
                {
                  label: (
                    <TabBadge
                      label={locale.General}
                      hasErrors={localStore.generalTabHasErrors}
                    />
                  ),
                  value: "general",
                  content: () => (
                    <FormTab horizontal>
                      <FormSection fullWidth>
                        <ContractForm />
                      </FormSection>

                      <FormSection
                        fullWidth
                        title={locale.customerContractEdit.contactPerson}
                      >
                        {localStore.form.values.contactPerson?.map((p, i) => (
                          <ContactPersonForm
                            name={`contactPerson.${i}`}
                            key={i}
                            onRemove={() => localStore.handleRemoveContact(i)}
                          />
                        ))}
                        <div
                          style={{
                            paddingTop: "15px",
                            display: "flex",
                            justifyContent: "flex-end"
                          }}
                        >
                          <Button
                            onClick={localStore.handleAddContact}
                            color={"secondary"}
                          >
                            {locale.Add}
                          </Button>
                        </div>
                      </FormSection>
                    </FormTab>
                  )
                }
              ]}
              // topbarProps={{
              //   children: (
              //     <Observer>
              //       {() => (
              //         <Typography variant="h6">
              //           {localStore.form.values.contractNumber &&
              //             locale.customerContractProfile.title(
              //               localStore.form.values.contractNumber
              //             )}
              //         </Typography>
              //       )}
              //     </Observer>
              //   )
              // }}
            />
            <FormxDebugger />
          </Form>
        </CustomerContractEditorStoreContext.Provider>
      </ErrorBoundary>
    );
  });
}
